/** Language display helpers shared across app and extension settings. */

const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English',
  hu: 'Hungarian',
  de: 'German',
  es: 'Spanish',
  fr: 'French',
  it: 'Italian',
  pt: 'Portuguese',
  nl: 'Dutch',
  pl: 'Polish',
  ru: 'Russian',
  ja: 'Japanese',
  zh: 'Chinese',
  ko: 'Korean',
};

export function getLanguageName(code: string | null | undefined): string {
  if (!code) return 'Unknown';
  return LANGUAGE_NAMES[code.toLowerCase()] ?? code.toUpperCase();
}

export const LANGUAGE_OPTIONS = Object.entries(LANGUAGE_NAMES).map(([value, label]) => ({
  value,
  label,
}));
